import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../../Api';
import makeConnectTo from '../../../util/makeConnectTo';
import { message } from 'antd';
import SubscriptionFrequencyOption from '../SubscriptionFrequencyOption';

const NoticesContext = React.createContext();

const name = 'noticesDataStore';

export const connectToNotices = makeConnectTo(NoticesContext, name);

export default class NoticesDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		notices: [],
		subscriptionFrequency: '',
		isLoading: true,
		isSubscriptionFrequencyLoading: true,
	};

	render() {
		const noticesDataStore = this.getStore();
		return (
			<NoticesContext.Provider value={noticesDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(noticesDataStore)
					: this.props.children}
			</NoticesContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchNotices();
		this.fetchSubscriptionPreference();
	}

	componentWillUnmount() {
		if (this.noticesFetch && this.noticesFetch.cancel) {
			this.noticesFetch.cancel();
		}
		if (
			this.subscriptionPreferencesFetch &&
			this.subscriptionPreferencesFetch.cancel
		) {
			this.subscriptionPreferencesFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
		refresh: () => this.refreshNotices(),
		changeStatus: (noticeId, status) => this.changeStatus(noticeId, status),
		changeSubscriptionPreference: subscriptionFrequencyOption =>
			this.changeSubscriptionPreference(subscriptionFrequencyOption),
	});

	refreshNotices = () => {
		this.setState({
			isLoading: true,
		});
		this.fetchNotices();
		return this.noticesFetch.promise;
	};

	fetchNotices = () => {
		const request = api.cancelableGet(`/api/v1/me/notifications`);
		request.promise.then(this.cacheApiResponse);
		this.noticesFetch = request;
	};

	cacheApiResponse = apiResponse => {
		const notices = apiResponse && this.getNotices(apiResponse);
		this.setState({
			notices:
				notices &&
				notices.sort(
					(a, b) => new Date(b.updatedDate) - new Date(a.updatedDate),
				),
			isLoading: false,
		});
	};

	getNotices = apiResponse => {
		const {
			userNotices,
			usersById,
			userAvatarsByAppUserId,
			organizationsById,
		} = apiResponse;
		return (
			userNotices &&
			userNotices.map(notice => {
				return {
					...notice,
					source: this.getSourceInfo(
						notice.sourceAppUserId,
						userAvatarsByAppUserId[notice.sourceAppUserId],
						usersById[notice.sourceAppUserId] &&
							usersById[notice.sourceAppUserId].orgID &&
							organizationsById[
								usersById[
									notice.sourceAppUserId
								].orgID.toLowerCase()
							],
					),
				};
			})
		);
	};

	getSourceInfo = (appUserId, userAvatar, organization) => {
		var source = {};
		if (organization) {
			source.userAvatar = userAvatar && userAvatar;
			source.organization = organization.name;
			source.appUserId = appUserId;
		}
		return source;
	};

	fetchSubscriptionPreference = () => {
		const request = api.cancelableGet(
			`/api/v1/subscriptions/homepageLane/310`,
		);
		request.promise.then(this.cacheSubscriptionApiResponse);
		this.subscriptionPreferencesFetch = request;
	};

	cacheSubscriptionApiResponse = apiResponse => {
		this.setState({
			subscriptionFrequency: apiResponse.frequency,
			isSubscriptionFrequencyLoading: false,
		});
	};

	changeStatus(noticeId, status) {
		api.put(`/api/v1/me/notifications/${noticeId}/status/${status}`).then(
			() => {
				this.fetchNotices();
			},
		);
	}

	changeSubscriptionPreference = subscriptionFrequencyOption => {
		api.post(
			`/api/v1/subscriptions/homepageLane/310/frequency/${subscriptionFrequencyOption}`,
		).then(() => {
			this.fetchSubscriptionPreference();
			if (
				subscriptionFrequencyOption ===
				SubscriptionFrequencyOption.never
			) {
				message.success(
					<span>
						You will no longer receive emailed summaries of
						Edelweiss notification
					</span>,
				);
			} else {
				message.success(
					<span>
						You will receive a summary of Edelweiss notifications
						(if any) via email on a {subscriptionFrequencyOption}{' '}
						basis
					</span>,
				);
			}
		});
	};
}
